import { dataLayerEvents } from "domain/SeoAndAnalytics/GoogleAnalytics/dataLayerEvents";

export const zoomDataLayerEvents = {
  aiZoomTriggeredEvent: dataLayerEvents.submitAiZoomTriggeredEvent,
  aiZoomNotTriggeredEvent: dataLayerEvents.submitAiZoomNotTriggeredEvent,
};
